import { useEffect, useState } from "react";
import { MDBCard, MDBCardBody, MDBView } from "mdbreact";
import { useDispatch, useSelector } from "react-redux";
import { BROWSE } from "../../../../../services/redux/slices/assets/persons/applicants";
import { BROWSE as BROWSE_BRANCHES } from "../../../../../services/redux/slices/assets/branches";
import { useToasts } from "react-toast-notifications";
import Access from "./modal";
import TableLoading from "../../../../../components/tableLoading";
import ViewCredential from "./viewCredential";
import { capitalize } from "lodash";
import Body from "./body";

export default function Applicants() {
  const { token, activePlatform } = useSelector(({ auth }) => auth),
    {
      collections,
      message,
      isSuccess,
      isLoading,
      branches: branchSelections,
    } = useSelector(({ applicants }) => applicants),
    [applicants, setApplicants] = useState([]),
    [activeBranch, setActiveBranch] = useState("all"),
    dispatch = useDispatch(),
    { addToast } = useToasts();

  const branchId =
    activePlatform?.branchId || activePlatform?.branch?._id || "";
  const companyReference =
    activePlatform?.branch?.companyId ||
    activePlatform?.companyId ||
    activePlatform?.company ||
    "";
  const companyId =
    typeof companyReference === "object"
      ? companyReference?._id || ""
      : companyReference;

  useEffect(() => {
    if (message) {
      addToast(message, {
        appearance: isSuccess ? "success" : "error",
      });
    }
  }, [isSuccess, message, addToast]);

  useEffect(() => {
    if (token && (companyId || branchId)) {
      dispatch(
        BROWSE({
          token,
          data: companyId
            ? { companyId }
            : { branch: branchId, branchId },
        })
      );
    }
  }, [branchId, companyId, dispatch, token]);

  useEffect(() => {
    if (token && companyId) {
      dispatch(BROWSE_BRANCHES({ token, key: { companyId } }));
    }
  }, [companyId, dispatch, token]);

  useEffect(() => {
    const _collections = [...collections].filter(({ status, branch }) => {
      if (activeBranch === "all") {
        return ["petition", "pending"].includes(status);
      } else {
        return ["petition", "pending"].includes(status) &&
          activeBranch === branch?._id;
      }
    });

    console.log("_collections", collections);
    setApplicants(_collections);
  }, [collections, activeBranch]);

  return (
    <>
      <MDBCard narrow className="pb-3">
        <MDBView
          cascade
          className="gradient-card-header blue-gradient py-2 mx-4 d-flex justify-content-between align-items-center"
        >
          <span className="ml-3">Applicant List</span>
          <div className="d-flex align-items-center ">
            <span className="mr-1">Branch:</span>
            <select
              className="form-control"
              style={{ width: "15rem" }}
              onChange={({ target }) => setActiveBranch(target.value)}
            >
              <option value={"all"}> All</option>
              {branchSelections.map(({ _id, name = "", displayname = "" }) => (
                <option key={_id} value={_id}>
                  {capitalize(name || displayname)}
                </option>
              ))}
            </select>
          </div>
        </MDBView>
        <MDBCardBody>
          {!isLoading ? <Body applicants={applicants} /> : <TableLoading />}
        </MDBCardBody>
      </MDBCard>
      <Access />
      <ViewCredential />
    </>
  );
}
